import { isNumber } from 'lodash';
import moment from 'moment';

import formatCurrency from 'Helper/formatCurrency';
import formatNumber from 'Helper/formatNumber';

const getReportSessionResponse = (response) => {
  const totalData = response?.totalData ?? 0;
  const totalPage = response?.totalPage ?? 0;
  const isDataExist = response?.isDataExist;
  const lastSync = moment(response?.lastSync).format('DD MMMM YYYY, HH:mm:ss');

  const reports = response?.sessions?.map((item) => {
    const startedAt = item?.schedule?.startedAt ? moment(item?.schedule?.startedAt).format('DD MMM YYYY, HH:mm ') : '-';
    const endedAt = item?.schedule?.endedAt ? moment(item?.schedule?.endedAt).format('DD MMM YYYY, HH:mm ') : '-';
    const title = item?.schedule?.title ?? '-';
    const brands = item?.accountLivestreams?.brands.length ? item?.accountLivestreams?.brands?.map((item) => item?.name)?.join(', ') : '-';
    const platform = item?.accountLivestreams?.ecommerce?.name ?? '-';
    const hosts = item?.schedule?.hosts?.length ? item?.schedule?.hosts?.map((item) => item?.name)?.join(', ') : '-';
    const studio = item?.schedule?.studio?.name ?? '-';
    const duration = `${formatNumber(item.hours || 0, 1)} Jam`;
    const revenue = isNumber(item?.revenue) ? formatCurrency(item?.revenue) : '-';
    const viewer = formatNumber(item?.viewer || 0, 1);
    const avgViewDuration = item?.fulltimeAvgViewDuration ?? '-';
    const buyer = formatNumber(item?.buyer || 0, 1);
    const conversationRate = `${formatNumber(item?.conversationRate || 0, 1)}%`;
    const ctr = `${formatNumber(item?.ctrPercentage || 0, 1)}%`;
    const errPercentage = `${formatNumber(item?.errPercentage || 0, 1)}%`;
    const averageOrderValue = item?.averageOrderValue ? formatCurrency(item?.averageOrderValue) : '-';

    const account = {
      accountLivestreams: item?.accountLivestreams,
      brand: item?.accountLivestreams?.brands?.length ? item?.accountLivestreams?.brands[0]?.name : '-',
      accountType: item?.accountLivestreams?.accountType?.name || '-',
    };

    return {
      startedAt,
      endedAt,
      title,
      account,
      brands,
      platform,
      hosts,
      studio,
      duration,
      revenue,
      viewer,
      avgViewDuration,
      buyer,
      conversationRate,
      ctr,
      errPercentage,
      averageOrderValue
    };
  });

  return { reports, totalData, totalPage, isDataExist, lastSync };
};

export default getReportSessionResponse;
